import React, { useState } from 'react';
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import { auth, browserSessionPersistence, firestore} from './firebase';
import { setPersistence, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { doc, updateDoc } from "firebase/firestore";



function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [attempts, setAttempts] = useState(0);

  // Funzione per login
  const Accedi = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setErrorMessage("Inserisci email e password");
      return;
    }

    try {
      await setPersistence(auth, browserSessionPersistence);
      const userCredential = await signInWithEmailAndPassword(auth, email, password);

      await userCredential.user.reload();
      if (!userCredential.user.emailVerified) {
        setErrorMessage("Devi prima verificare la tua email prima di accedere! Controlla la posta (anche nello spam).");
        await auth.signOut();
        return;
      }else{
        const userRef = doc(firestore, "users", userCredential.user.uid);
        await updateDoc(userRef, { emailVerified: true });
      }

      navigate('/');
    } catch (error) {
      setAttempts(prev => prev + 1);

      // Mostra messaggio errore
      setErrorMessage("Email o password errata");

      // Se più di 3 tentativi, mostra pulsante reset
    }
  };

  // Funzione per reset password
  const ResetPassword = async () => {
    if (!email) {
      alert("Inserisci la tua email per ricevere il link di reset");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Controlla la tua email per resettare la password!");
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        alert("Email non esistente. Registrati!");
      } else {
        alert(error.message);
      }
    }
  };

  return (
    <div className='body'>
      <div className='login'>
        <Link to="/"><img className="login_logo" src="/logo_cinque.png" alt='Logo'/></Link>

        <div className='login_container'>
          <h1>Accedi</h1>
          <form onSubmit={Accedi}>
            <h5>E-mail</h5>
            <input
              type='email'
              value={email}
              onChange={e => setEmail(e.target.value)}
            />

            <h5>Password</h5>
            <input
              type='password'
              value={password}
              onChange={e => setPassword(e.target.value)}
            />

            <button type='submit' className='loginButton'>
              Clicca per accedere
            </button>

            {errorMessage && <p className="error">{errorMessage}</p>}

            {attempts >= 3 && (
              <button
                type="button"
                onClick={ResetPassword}
                className="resetPasswordButton"
              >
                Hai dimenticato la password?
              </button>
            )}

            <p>Se non hai un account, clicca sul pulsante qui sotto per registrarti!</p>
            <Link to="/Sign_in"><input type='button' value="Registrati"/></Link>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login;
